<template>
  <section class="why-section">
    <div class="section__container">
      <div class="grid-container">
        
        <div class="image__wrapper">
          <img :src="require('@/assets/img/understanding-digu-img.jpeg')" alt="DIGU illustration">
        </div>
        <div class="content__wrapper">
          <p class="o600 why__subtitle section__subtitle-2">Understanding <span class="underline">DIGU</span></p>
        </div>
        <div class="description__wrapper">
          <p class="m500 why__description section__description-2">
            DIGU stands for Driving Innovation and Growth Unlimited and is more than just an acronym; it carries profound significance in Nepali (Newari) culture. The concepts of clan, descent, and generation symbolize who we are, where we come from, and our commitment to supporting Nepal’s future. Rooted in rich heritage, DIGU reflects the flourishing of potential, much like a lotus blooming from humble beginnings to global success. </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UnderstandingDigu',
};
</script>

<style scoped>
.why-section {
  padding-block: 4rem 5rem;
  background: #CFECFC;
  overflow: hidden;
}

.section__container {
  max-width: var(--about-content-max, 1400px);
  margin: 0 auto;
  width: 100%;
  padding-inline: var(--about-page-gutter, clamp(1rem, 4vw, 2rem));
}

.grid-container {
  display: grid;
  gap: 1rem;
  min-width: 0;
}

.image__wrapper,
.content__wrapper,
.description__wrapper {
  min-width: 0;
}

.image__wrapper img {
  width: min(100%, 500px);
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  border-radius: 0.8rem;
}

.why__subtitle {
  color: #17171F;
  font-size: clamp(32px, 5vw, 56px) !important;
  text-align: left;
}

.why__description {
  margin-top: 0;
  text-align: left;
  color: var(--dark-2);
  width: 100%;
  overflow-wrap: anywhere;
}

.underline {
  position: relative;
  display: inline-block;
}

.underline::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -5px;
  width: 100%;
  height: 10px;
  background-image: url("@/assets/img/underline.svg");
  background-repeat: no-repeat;
  background-size: contain;
  transform: translateX(-50%);
}
@media (min-width: 1200px) {
  .why__description {
    margin-top: -1rem;
    
  }

}
@media (min-width: 960px) {
  .grid-container {
    grid-template-columns: 1fr 0.9fr; 
    grid-template-areas: 
      "title image"
      "description image";
    align-items: center;
  }

  .content__wrapper {
    grid-area: title;
    /* padding-right: 2rem; */
  }

  .image__wrapper {

    grid-area: image;
    
  }

  .description__wrapper {

    grid-area: description;
    padding-right: 2rem;
  }
}

@media (max-width: 959px) {
  .why-section {
    padding-block: 3rem 4rem;
  }

  .section__container {
    padding-inline: var(--about-mobile-section-gutter, calc(1rem + 12px));
  }

  .grid-container {
    grid-template-columns: 1fr;
  }
  
  .why__subtitle,
  .why__description {
    text-align: left;
  }
  
  .image__wrapper {
    order: 1;
    margin-top: 0.75rem;
  }
  
  .description__wrapper {
    order: 2;
  }
}
/*   */
</style>
